export type AtHomeAppointmentActionConfigItem = {
  label: string;
  type: "primary" | "secondary" | "success" | "check-in";
  nextStatus: string;
  confirmMessage?: string;
  openDirectionsAfterUpdate?: boolean;
  showDirections?: boolean;
};

export const atHomeAppointmentConfig: Record<string, AtHomeAppointmentActionConfigItem> = {
  Upcoming: {
    label: "Leave Now",
    type: "primary",
    nextStatus: "in_transit",
    openDirectionsAfterUpdate: false,
  },
  "In Transit": {
    label: "Arrived",
    type: "secondary",
    nextStatus: "waiting",
    showDirections: true,
  },
  waiting: {
    label: "Start Visit",
    type: "primary",
    nextStatus: "attending",
  },
  attending: {
    label: "Complete",
    type: "success",
    nextStatus: "check_out",
  },
  onhold: {
    label: "",
    type: "secondary",
    nextStatus: "",
  },
  completed: {
    label: "",
    type: "secondary",
    nextStatus: "",
  },
  cancelled: {
    label: "",
    type: "secondary",
    nextStatus: "",
  },
  failed: {
    label: "",
    type: "secondary",
    nextStatus: "",
  },
};

export const atHomeStatusToActionConfigKey: Record<string, string> = {
  Upcoming: "Upcoming",
  Confirmed: "Upcoming",
  confirmed: "Upcoming",
  Waiting: "waiting",
  waiting: "waiting",
  "In Transit": "In Transit",
  In_transit: "intransit",
  in_transit: "intransit",
  attending: "attending",
  Attending: "attending",
};
